export const BASE_URL = 'https://cms.nucleusfarma.com/api';
